module.exports = __webpack_public_path__ + "media/images/step-line-5290b2228f1e933c60926018e7b5caa2.svg";